/* eslint-disable import/no-cycle */
import { asyncComponent } from '@telus/isomorphic-core'

const CustomerSelectAccount = process.env.BROWSER
  ? asyncComponent(/* istanbul ignore next */ () => import('./Container'))
  : require('./Container').default

export default CustomerSelectAccount